import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { CmsConfig, provideDefaultConfig, UrlModule } from '@spartacus/core'
import { SpinnerModule } from '@spartacus/storefront'
import { UserPermissionsGuard } from '../../../../../guards/user-permissions.guard'
import { SharedModule } from '../../../../shared/shared.module'
import { DispenserAgreementDetailComponent } from './dispenser-agreement-detail.component'

@NgModule({
  declarations: [DispenserAgreementDetailComponent],
  imports: [RouterModule, UrlModule, SharedModule, SpinnerModule],
  providers: [
    provideDefaultConfig({
      cmsComponents: {
        DispenserAgreementDetailsComponent: {
          component: DispenserAgreementDetailComponent,
          guards: [UserPermissionsGuard]
        }
      }
    } as CmsConfig)
  ]
})
export class DispenserAgreementDetailModule {}
